import { type SingleSelectedValueFilter } from '../types'
import DateFilter from './DateFilter'

const BeforeDateFilter = (props: SingleSelectedValueFilter) => {
  return <DateFilter {...props} rangeType='Less than' />
}

export default BeforeDateFilter
